import { render } from "./user_field.vue?vue&type=template&id=12d8332b&lang=pug"
import script from "./user_field.vue?vue&type=script&lang=js"
export * from "./user_field.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__